export const micEnableInstructionsChrome = `This question requires you to record your answer(s).
 Please follow the instructions to enable your microphone permission:
     1. Go to the address bar in the Chrome browser.
     2. Click the camera icon with the X.
     3. Click Always allow ${window.location.protocol}//${window.location.hostname} to access your microphone.
     4. Click Done.
     5. Click Reload.`;

export const myCoursesFilter = {
	Grammar: {
		themefilterclass: 'gr',
		bgColor: 'dropdownbg1',
		displayText: 'Improve Grammar',
		themeclass: ' panel-course-green',
		adaptiveVideo: 'video_green',
		adaptiveTextClass: 'adaptive-text-green',
	},
	BuildVocabulary: {
		themefilterclass: 'bv',
		bgColor: 'dropdownbg2',
		displayText: 'Build Vocabulary',
		themeclass: ' panel-course-violet',
		adaptiveVideo: 'video_violet',
		adaptiveTextClass: 'adaptive-text-violet',
	},
	SpeakBetter: {
		themefilterclass: 'sb',
		bgColor: 'dropdownbg3',
		displayText: 'Speak Better',
		themeclass: ' panel-course-red',
		adaptiveVideo: 'video_red',
		adaptiveTextClass: 'adaptive-text-red',
	},
	WriteBetter: {
		themefilterclass: 'wb',
		bgColor: 'dropdownbg4',
		displayText: 'Write Better',
		themeclass: ' panel-course-yellow',
		adaptiveVideo: 'video_yellow',
		adaptiveTextClass: 'adaptive-text-yellow',
	},
	Strategies: {
		themefilterclass: 'st',
		bgColor: 'dropdownbg5',
		displayText: 'Learn Strategies',
		themeclass: ' panel-course-blue',
		adaptiveVideo: 'video_blue',
		adaptiveTextClass: 'adaptive-text-blue',
	},
	LiveClass: {
		themefilterclass: 'lc',
		bgColor: 'dropdownbg7',
		displayText: 'Attend Live Class',
		themeclass: ' panel-course-eden',
		adaptiveVideo: 'video_eden',
		adaptiveTextClass: 'adaptive-text-eden',
	},
	ListenBetter: {
		themefilterclass: 'lb',
		bgColor: 'dropdownbg8',
		displayText: 'Listen Better',
		themeclass: ' panel-course-olive',
		adaptiveVideo: 'video_olive',
		adaptiveTextClass: 'adaptive-text-olive',
	},
	Challenge: {
		themefilterclass: 'tc',
		bgColor: 'dropdownbg9',
		displayText: 'Take up a Challenge',
		themeclass: ' panel-course-crimson',
		adaptiveVideo: 'video_crimson',
		adaptiveTextClass: 'adaptive-text-crimson',
	},
	Any: {
		themefilterclass: 'box',
		bgColor: 'dropdownbg6',
		displayText: 'Improve All Skills',
		themeclass: ' panel-course-default',
		adaptiveVideo: 'video',
		adaptiveTextClass: 'adaptive-text-red',
	},
	JustForMe: {
		themefilterclass: 'jfm',
		bgColor: 'dropdownbg6 animation-examples-2',
		displayText: 'See activities just for me',
		themeclass: ' panel-course-default',
		adaptiveVideo: 'video',
		adaptiveTextClass: 'adaptive-text-red',
	},
};

export const ChoiceSeq = ['a', 'b', 'c', 'd', 'e'];

export const errorMsg = 'Please answer this question';

export const getOlympiadUserDetails =
	"To get updates on your Olympiad results, you may provide us your parent's details:";

export const detailsForCoach =
	'Please update your mobile number and email id before scheduling call.';

export const taskSubmitSuccessful = `Thank you for submitting your assignment. Schedule your next call.<br/>
We will need some time to review your assignment, please schedule your call at a slot that is available <b>48 hours from now.</b> Thank you!`;

export const playAudioInstruction = `<span> Listen to the audio and answer the questions below.
For each question, Click on the  ' <i class="arrowDown fa fa-angle-down"></i> ' to see the answer options.</span>`;

export const playVideoInstruction = `<span> Listen to the audio and answer the questions below.
For each question, Click on the  ' <i class="arrowDown fa fa-angle-down"></i> ' to see the answer options.</span>`;

export const readInstruction = `<span>Read the passage and answer the questions below.
For each question, Click on the ' <i class="arrowDown fa fa-angle-down"></i> ' to see the answer options.</span>`;

export const instructionData = {
	D: {
		instrnClassName: 'dailytest dailytest-pink',
		instrnIdName: 'dailytest-instruction-popup',
		instrnImage: 'dailytest_pink.png',
	},
	S: {
		instrnClassName: 'summativetest summativetest-red',
		instrnIdName: 'summativetest-instruction-popup',
		instrnImage: '',
	},
	F: {
		instrnClassName: 'formative formative-Def',
		instrnIdName: 'formative-instruction-popup',
		instrnImage: 'board_default.png',
	},
	W: {
		Grammar: {
			instrnClassName: 'webisode webisode-Gr',
			instrnImage: 'video_green',
			instrnIdName: 'webisode-instruction-popup',
		},
		BuildVocabulary: {
			instrnClassName: 'webisode webisode-Voc',
			instrnImage: 'video_violet',
			instrnIdName: 'webisode-instruction-popup',
		},
		SpeakBetter: {
			instrnClassName: 'webisode webisode-Sp',
			instrnImage: 'video_red',
			instrnIdName: 'webisode-instruction-popup',
		},
		WriteBetter: {
			instrnClassName: 'webisode webisode-Wr',
			instrnImage: 'video_yellow',
			instrnIdName: 'webisode-instruction-popup',
		},
		Strategies: {
			instrnClassName: 'webisode webisode-St',
			instrnImage: 'video_blue',
			instrnIdName: 'webisode-instruction-popup',
		},
		Any: {
			instrnClassName: 'webisode webisode-Def',
			instrnImage: 'video_default',
			instrnIdName: 'webisode-instruction-popup',
		},
		LiveClass: {
			instrnClassName: 'webisode webisode-Lc',
			instrnImage: 'video_eden',
			instrnIdName: 'webisode-instruction-popup',
		},
		ListenBetter: {
			instrnClassName: 'webisode webisode-Lb',
			instrnImage: 'video_olive',
			instrnIdName: 'webisode-instruction-popup',
		},
		Challenge: {
			instrnClassName: 'webisode webisode-Tc',
			instrnImage: 'video_crimson',
			instrnIdName: 'webisode-instruction-popup',
		},
	},
};

export const LSRW = {
	L: 'Listening_B',
	R: 'Reading_B',
	W: 'Writing_B',
	S: 'Speaking_B',
};

export const ProfileTabs = {
	Personal: {
		redirectLink: '/profile',
		PageName: 'Personal Information',
		icon: 'fa fa-user',
	},
	Accounts: {
		redirectLink: '/settings',
		PageName: 'Account Settings',
		icon: 'fa fa-cogs',
	},
	/*History: {
		redirectLink: '/history',
		PageName: 'History',
		icon: 'fa fa-file-text',
	},*/
};

export const sidebarDetails = {
	MyDashboard: {
		redirectLink: 'mydashboard',
		PageName: 'My Dashboard',
	},
	KidsCourses: {
		redirectLink: 'parent/dashboard',
		PageName: 'Child Profiles',
		isParent: 1,
	},
/*	CoachCalls: {
		redirectLink: 'coach',
		PageName: 'Coach Calls',
	},
	LiveClasses: {
		redirectLink: 'live',
		PageName: 'Live Classes',
	},
	OnlineLessons: {
		redirectLink: 'online',
		PageName: 'Online Lessons',
	},*/

	BuyaCourse: {
		redirectLink: 'buycourse',
		PageName: 'Buy a Course',
	},
	Profile: {
		isMobile: 1,
		redirectLink: 'profile',
		PageName: 'Profile',
	},
/*	Settings: {
		redirectLink: 'settings',
		PageName: 'Settings',
	},*/
/*	History: {
		isMobile: 1,
		redirectLink: 'history',
		PageName: 'History',
	},*/
};

export const retryMsg = [
	'You have used up all chances to record your answer. Click on Submit to continue.',
	'You have 1 more chance available to record your answer. Click on Submit to submit the current recording.',
	'You have 2 chances available to record your answer. Click on Submit to submit the current recording.',
	'You have 3 chances available to record your answer.',
];

export const clozePassageScoreClass = {
	correct: {
		answerBgClass: 'correct',
		answerClass: 'qcorrect',
		userAnsClass: 'correct-ans',
		userAnsImg: 'answergreen.png',
	},
	wrong: {
		answerBgClass: 'wrong',
		answerClass: 'qwrong',
		userAnsClass: 'wrong-ans',
		userAnsImg: 'answerred.png',
	},
	ungraded: {
		answerBgClass: 'ungraded',
		answerClass: 'qungraded',
		userAnsClass: 'ungraded-ans',
		userAnsImg: 'answerblue.png',
	},
};

export const videoJsOptions = {
	controls: true,
	width: 640,
	height: 60,
	fluid: false,
	responsive: true,
	controlBar: {
		fullscreenToggle: false,
		volumePanel: false,
	},
	plugins: {
		wavesurfer: {
			src: 'live',
			waveColor: '#243257',
			progressColor: '#333',
			debug: true,
			cursorWidth: 1,
			msDisplayMax: 0,
			hideScrollbar: true,
		},
		record: {
			audio: true,
			video: false,
			maxLength: 60,
			audioRecorderType: 'StereoAudioRecorder',
			audioMimeType: 'audio/wav',
			audioChannels: 1,
			audioEngine: 'recorder.js',
			debug: true,
		},
	},
};

export const userEducationOptions = [
	'Post Graduation',
	'Under Graduation',
	'Diploma',
	'SSC / HSC',
	'6th grade to 10th grade',
	'1st to 5th grade',
];
export const userTypeOptions = [
	'Working Professional',
	'Competitive Exam Aspirant',
	'Job Seeker',
	'Teacher/Trainer',
	'Student',
	'Homemaker',
	'Retired Personnel',
	'Others',
];
export const userJobOptions = [
	'Government service',
	'Private company employee',
	'Self-employed',
	'Entrepreneur',
	'Business Person',
	'Consultant',
	'Others',
];
export const jobTypeOptions = [
	'Administrative/ Office Staff',
	'Agriculturist',
	'Corporate/ Client / Customer Services',
	'Corporate/ Client / Customer Sales',
	'Design',
	'Education, Curriculum & Teaching',
	'Facilities / Grounds Management & Maintenance',
	'Finance Management',
	'Front office',
	'Healthcare / Pharma/ Medical & Nursing',
	'HR, Training and Organisational Development',
	'Information & Communications Technology',
	'Marketing',
	'Mechanical / Automotive Engineering',
	'Operations/Production',
	'Transport, Utilities Staff ',
	'Legal Officers and Practitioners',
	'Others',
];
export const preparingExamOptions = [
	'Bank Clerical',
	'Bank PO',
	'Union Civil Services ',
	'State Civil Services',
	'SSC-CGL',
	'SSC-CHSL',
	'Indian Railways - RRB',
	'LIC AAO',
	'Others',
];
export const skillsOptions = [
	'Reading Comprehension',
	'Essay Writing',
	'Active and Passive voice',
	'Phrases and Idioms',
	'Cloze Test',
	'Precis Writing',
	'Group Discussion',
	'Error Spotting',
	'Others',
];
export const primaryPurposeOptions = [
	'To prepare for a competitive exam',
	'To get a job',
	'To move to a better job',
	'To pursue higher studies',
	'To communicate better with my friends',
	'To communicate better with my colleagues',
	'To enjoy English TV shows and Movies better',
	'To read the Newspaper well',
	'Others',
];
export const primaryPurpose = {
	Student: [
		'To prepare for a competitive exam',
		'To get a good Placement',
		'I have a job offer and would like to be fluent in english',
		'I want to study abroad and would like to improve my English',
		"I'm preparing for TOEFL/IELTS/GRE/GMAT",
		'Others',
	],
	WorkingProfessional: [
		'To prepare for a competitive exam',
		'To apply to a better job',
		'To pursue higher studies',
		'To communicate with my colleagues over email',
		'To communicate with me colleagues at meetings',
		'To enjoy English TV shows and Movies better',
		'To read the Newspaper well',
		'Others',
	],
};
export const title = {
	'Working Professional': 'Job Related',
	'Competitive Exam Aspirant': 'Competitive Exam Related',
	'Job Seeker': 'More About You',
	'Teacher/Trainer': 'More About You',
	Student: 'Student Related',
	Homemaker: 'More About You',
	'Retired Personnel': 'More About You',
	Others: 'More About You',
};
export const studentGrade = [
	'Class 3',
	'Class 4',
	'Class 5',
	'Class 6',
	'Class 7',
	'Class 8',
	'Class 9',
	'Class 10',
];

export const goBackTimed = `This is a timed assessment. You may lose your attempt. 
Do you still want to go back?`;

export const goBackRegular = `Are you sure you want to go back?`;

export const noInternet = `We are unable to initiate the course as your internet speed is low. <br/>
Please change your network and try again.`;

export const pageTitle = {
	live: 'Live Classes',
	online: 'Online Lessons',
	coach: 'Coach Program',
};

export const kid_img = [
	'kid-girl-1.svg',
	'kid-boy-1.svg',
	'kid-boy-2.svg',
	'kid-boy-3.svg',
	'kid-boy-4.svg',
];

export const _months = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
